export default async function GetPaymentMaster(data) {
    let url = window.RealestateService + "/api/PaymentTypeMaster/GetPaymentTypeMaster";
    let head = {
         "content-type":"application/json",
        "accept":"*/*"
    }
    let response = await fetch(url, {
        method:"GET",
        headers:head,
    }).then(res=>res.json()).catch(res=>res)

    return response;
}